'use strict';

var React = require('react');

var SvgCardReaderTapMajor = function SvgCardReaderTapMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 8a6 6 0 0 1 6-6 1 1 0 0 0 0-2 8 8 0 0 0-8 8 1 1 0 0 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6a2 2 0 0 0-2 2 1 1 0 0 1-2 0 4 4 0 0 1 4-4 1 1 0 0 1 0 2zm7 0h-4.5a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h4.5v-14zm3.5 0a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-1.5v-14h1.5z"
  }));
};

exports.SvgCardReaderTapMajor = SvgCardReaderTapMajor;
